// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__1kVg8","label":"Labeled_label__iqMzN","divider":"Labeled_divider__1Gjft"};